import { Analytics } from "@shared"

import ButtonComponent from "./Button"

const Button = Analytics(ButtonComponent, true)

export { Button }
export default Button
